import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFrontierExposure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 17"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.307 3.54A1.86 1.86 0 0 0 9.38 1.86C9.379.832 8.539 0 7.503 0a1.87 1.87 0 0 0-1.875 1.86c0 .74.439 1.38 1.072 1.68v3.28a1.7 1.7 0 0 0-.268.156l-2.683-1.52a1.86 1.86 0 0 0-.935-1.754 1.883 1.883 0 0 0-2.562.68 1.85 1.85 0 0 0 .82 2.61v3.015a1.85 1.85 0 0 0-.82 2.61 1.883 1.883 0 0 0 2.562.68 1.85 1.85 0 0 0 .931-1.752l1.692-.96a2.9 2.9 0 0 1-.797-1.384l-1.692.963a2 2 0 0 0-.268-.157V6.993q.142-.067.268-.156l2.683 1.52a1.861 1.861 0 0 0 1.065 1.823v3.28a1.86 1.86 0 0 0-1.072 1.68c0 1.027.841 1.86 1.876 1.86a1.87 1.87 0 0 0 1.876-1.86c0-.74-.44-1.38-1.072-1.68v-3.28q.141-.065.268-.156l2.683 1.52a1.86 1.86 0 0 0 .93 1.754c.898.515 2.044.209 2.563-.68a1.85 1.85 0 0 0-.82-2.61V6.992q.069-.03.133-.07a1.85 1.85 0 0 0 .687-2.54 1.875 1.875 0 0 0-2.556-.68 1.85 1.85 0 0 0-.93 1.752l-1.696.96c.386.372.667.85.798 1.384l1.694-.962q.13.089.268.156v3.014a2 2 0 0 0-.268.153L9.376 8.64q.005-.07.006-.143c0-.74-.438-1.382-1.071-1.68v-3.28z"
    />
  </svg>
);
export default SvgFrontierExposure;
